import React                      from 'react'
import { AutoComplete }           from 'antd'
import { AutoCompleteProps }      from 'antd/lib/auto-complete'
import { Observer }               from 'mobx-react'

import { FACTORY }                from '../09_model_app'

export const SelectDataSheet: React.FC< AutoCompleteProps > = ( props ) =>
<Observer render={ ( ) => 
{
  const data_sheets    = FACTORY.DATA_SHEET.data_for( { }, 0 )
      , data_source    = data_sheets.data.map( ds => ({ value: ds.id, text: ds.id }))
      , filter_clients = ( value: string, opt: any ) =>
          opt.props.children.match( new RegExp( value, "gi" ) ) !== null ;

  return <AutoComplete
           dataSource={ data_source }
           filterOption={ filter_clients }
           {...props}
         /> ;
} } /> ;
